var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCommunication = function SvgCommunication(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 36,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M29.5 20.425v4.396a5.105 5.105 0 0 1-5.105 5.104H5.75L1 34.675V15.853a5.105 5.105 0 0 1 5.105-5.105H10.5v4.573a5.105 5.105 0 0 0 5.105 5.104z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#F28230",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M39 6.353v18.822l-4.75-4.75H15.605a5.105 5.105 0 0 1-5.105-5.104V6.353a5.105 5.105 0 0 1 5.105-5.105h18.29A5.105 5.105 0 0 1 39 6.353"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F28230",
    stroke: "#F28230",
    strokeWidth: 2,
    d: "M17.625 10.93a.2.2 0 0 0 .055-.013.3.3 0 0 0 .082-.055c.04-.04.046-.066.047-.071a.28.28 0 0 0-.072-.178.14.14 0 0 0-.112-.048.2.2 0 0 0-.055.014.3.3 0 0 0-.082.055c-.04.04-.046.066-.046.071.004.079.035.14.072.178a.14.14 0 0 0 .111.048Zm.184-.137Zm-.367-.09ZM24.75 10.93a.2.2 0 0 0 .055-.013.3.3 0 0 0 .082-.055c.04-.04.046-.066.047-.071a.28.28 0 0 0-.072-.178.14.14 0 0 0-.112-.048.2.2 0 0 0-.055.014.3.3 0 0 0-.082.055c-.04.04-.046.066-.046.071.004.079.035.14.072.178a.14.14 0 0 0 .111.048Zm.184-.137Zm-.367-.09ZM31.875 10.93a.2.2 0 0 0 .055-.013.3.3 0 0 0 .081-.055c.04-.04.046-.066.047-.071a.28.28 0 0 0-.072-.178.14.14 0 0 0-.111-.048.2.2 0 0 0-.056.014.3.3 0 0 0-.081.055c-.04.04-.046.066-.047.071.004.079.036.14.072.178a.14.14 0 0 0 .112.048Zm.183-.137Zm-.367-.09Z"
  })));
};
export default SvgCommunication;